import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { PopupLoginComponent } from 'app/modules/popup-login/popup-login.component';
import { PopupSignUpComponent } from 'app/modules/popup-signup/popup-signup.component';
import { AbsPipe } from 'app/shared/abs.pipe';
import { WatchlistComponent } from '../watchlist/watchlist.component';

@Component({
    selector: 'app-stats-cards',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        AbsPipe,
        RouterModule,
        WatchlistComponent,
    ],
    templateUrl: './stats-cards.component.html',
})
export class StatsCardsComponent {
    isLoggedIn?: boolean;
    volumes = [];
    hausses = [];
    baisses = [];
    constructor( @Inject(PLATFORM_ID) private platformId,
        private route: ActivatedRoute,
        private loginService: LoginService,
        public dialog: MatDialog, private router: Router
    ) {
        this.isLoggedIn = this.loginService.getIsLogged();
        [this.volumes, this.hausses, this.baisses] =
            this.route.snapshot.data['principaux'];
    }

    signin(): void {
        this.dialog.open(PopupLoginComponent);
    }

    signup(): void {
        this.dialog.open(PopupSignUpComponent);
    }
    reloadPage(stockName:string,isin :string): void {
       if (isPlatformBrowser(this.platformId)) {
    
        this.router.navigate(['/actifs', stockName,isin])
          .then(() => {
            window.location.reload();
          });
      }
    }
}
